import { toast } from "sonner";

/** Avisos da UP Entrega quando o KDS chama o entregador — os mesmos textos da
 *  tela de Delivery. Ficam aqui porque a chamada agora sai do Desfazer
 *  (hooks/useDesfazer.js), 10 s depois do toque, e não mais da página. */
export function avisarEntregadorChamado() {
  toast.success("Entregador solicitado via UP Entrega!");
}

export function avisarFalhaUp(err) {
  const detail = err.response?.data?.detail;
  const code = typeof detail === "object" ? detail?.code : null;
  const msg = typeof detail === "object" ? detail?.message : (detail || "Erro ao solicitar entregador");
  if (code === "insufficient_balance") {
    const fmt = (v) => (v == null ? "?" : `R$ ${Number(v).toFixed(2).replace(".", ",")}`);
    toast.error("Saldo insuficiente na UP Entrega", { description: `Saldo ${fmt(detail?.current_balance)} · corrida ${fmt(detail?.delivery_price)} · faltam ${fmt(detail?.missing_amount)}. Recarregue em Configurações → Integração.`, duration: 10000 });
  } else if (code === "invalid_address") {
    toast.error("Endereço rejeitado pela UP Entrega", { description: msg, duration: 8000 });
  } else if (code === "unauthorized") {
    toast.error("Credenciais da UP Entrega inválidas", { description: "Verifique a API Key em Configurações → Integração.", duration: 8000 });
  } else {
    toast.error(`Falha no UP Entrega: ${msg}`);
  }
}
